import React from 'react';

const ThesisSection = () => {
  return (
    <section id="our-thesis" className="py-24 md:py-32 bg-[#1B4D3E] px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        <h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#F5F0EB] mb-12"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}>We don't chase trends.


        </h2>
        
        <div className="space-y-6 text-xl md:text-2xl text-[#E8E2DB] leading-relaxed">
          <p>We look for FBA businesses with a product portfolio that has real demand and clean operations

          </p>
          <p>
            Businesses that generate steady cash flow year after year.
          </p>
          <p>
            Our focus is Amazon brands in Home & Kitchen, Sports, Gardening, and similar categories. 
            Products built for durability, not virality.
          </p>
          <p>We buy businesses we intend to run responsibly, patiently, and with respect for what you've built.

          </p>
          <p className="text-white font-medium">

          </p>
          <p className="text-white font-medium">
            Just boring businesses doing boring things, boringly well.
          </p>
        </div>
      </div>
    </section>);

};

export default ThesisSection;